document.querySelectorAll('.prudan-product-form').forEach((form) => {
  const selector = form.querySelector('[data-variant-select]');
  if (!selector) return;
  const price = form.querySelector('[data-variant-price]');
  const submit = form.querySelector('[data-add-to-cart]');
  const quantity = form.querySelector('[name="quantity"]');
  const update = () => {
    const option = selector.options[selector.selectedIndex];
    const enabled = form.dataset.salesEnabled === 'true' && option?.dataset.available === 'true';
    if (price && option) {
      price.textContent = option.dataset.price;
      price.hidden = option.dataset.priceReady !== 'true';
    }
    if (submit) {
      submit.disabled = !enabled;
      submit.textContent = enabled ? 'Add to cart' : 'Currently unavailable';
    }
    if (quantity) quantity.disabled = !enabled;
  };
  selector.addEventListener('change', update);
  update();
});
